export class ContractsFilterDto {
    title: string = '';
    code: string = '';
    serviceProvider: string = '';
    showDeactivated: boolean = false;
    showDeleted: boolean = false;
}
